import React from "react";
import BlueFlower5 from "../assets/blue5.png"; // Adjust the path if necessary

const Blue5 = () => {
    return (
      <div class="absolute scale-200 z-1">
        <img 
          src={BlueFlower5} 
          alt="Blue Flower 5" 
          
        />
      </div>
    );
  };
  
  export default Blue5;